<template>
  <v-card>
    <v-card-title>
      Dodaj nowy kod
    </v-card-title>
    <v-card-text>
      <AddCode></AddCode>
    </v-card-text>
  </v-card>
</template>

<script>
import AddCode from "@/components/codes/AddCode";

export default {
  components: {
    AddCode,
  }
}
</script>